import bindNode from './bindnode/index.js';
import unbindNode from './unbindnode/index.js';
import checkObjectType from './_helpers/checkobjecttype.js';
export default function bindSandbox(object, node, evt) {
  if (typeof this === 'object' && this.isMatreshka) {
    // when context is Matreshka instance, use this as an object and shift other args
    evt = node;
    node = object;
    object = this;
  } else {
    // throw error when object type is wrong
    checkObjectType(object, 'bindSandbox');
  }
  unbindNode(object, 'sandbox', null, evt);
  return bindNode(object, 'sandbox', node, null, evt);
}